import { AlertTriangle } from 'lucide-react';
import BottomSheet from '../../../../components/ui/BottomSheet';
import { SideBadge } from '../ManualBadges';

function Field({ label, value }) {
  return (
    <div className="flex items-center justify-between py-1.5 border-b border-bg-border/50 last:border-0">
      <span className="text-2xs font-mono uppercase tracking-widest text-txt-label">{label}</span>
      <span className="text-xs font-mono text-txt-primary">{value}</span>
    </div>
  );
}

// ctx: { strategy, order }
export default function CancelOrderModal({ ctx, onConfirm, onCancel }) {
  if (!ctx) return null;
  const { strategy, order } = ctx;

  const body = (
    <>
      <h3 className="font-display font-semibold text-txt-primary mb-4">Cancel Order</h3>

      <div className="mb-4">
        <Field label="Strategy" value={strategy.strategyName} />
        <Field label="Symbol" value={order.symbol} />
        <div className="flex items-center justify-between py-1.5 border-b border-bg-border/50">
          <span className="text-2xs font-mono uppercase tracking-widest text-txt-label">Side</span>
          <SideBadge side={order.side} />
        </div>
        <Field label="Order Qty" value={order.orderQty} />
        <Field label="Filled Qty" value={order.filledQty} />
        <Field label="Pending Qty" value={order.pendingQty} />
        <Field label="Status" value={order.status} />
      </div>

      <div className="flex items-start gap-2 rounded-md border border-warn/30 bg-warn/10 px-3 py-2 mb-5">
        <AlertTriangle size={14} className="text-warn shrink-0 mt-0.5" />
        <span className="text-2xs font-mono text-txt-secondary">
          This will cancel only the pending unfilled quantity. Already filled quantity will remain as
          an open position.
        </span>
      </div>

      {/* Mobile (<lg): sticky footer within the BottomSheet's scrollable body, matching
          the other confirm sheets' idiom. lg: resets restore the desktop layout. */}
      <div className="sticky bottom-0 -mx-4 px-4 pt-3 pb-2 bg-bg-card border-t border-bg-border flex justify-end gap-3 lg:static lg:mx-0 lg:px-0 lg:pt-0 lg:pb-0 lg:bg-transparent lg:border-0">
        <button type="button" onClick={onCancel} className="btn-ghost min-h-[48px] lg:min-h-0">Cancel</button>
        <button type="button" onClick={() => onConfirm({ strategy, order })} className="btn-danger min-h-[48px] lg:min-h-0">
          Confirm Cancel
        </button>
      </div>
    </>
  );

  return (
    <>
      {/* Desktop (>=lg): unchanged centered modal */}
      <div className="hidden lg:flex fixed inset-0 z-50 items-center justify-center bg-black/60 backdrop-blur-sm p-4">
        <div className="card p-6 w-full max-w-sm animate-fade-in shadow-panel">
          {body}
        </div>
      </div>

      {/* Mobile (<lg): bottom-sheet presentation of the same content. */}
      <BottomSheet open onClose={onCancel} title="">
        {body}
      </BottomSheet>
    </>
  );
}
